import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

export const useClarityAdminGuard = () => {
  const { pathname } = useLocation();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'prod') return;

    const isAdminPath = pathname.startsWith('/admin');
    const wasAdminPath = previousPathnameRef.current.startsWith('/admin');

    previousPathnameRef.current = pathname;

    if (isAdminPath && window.clarity) {
      window.location.replace(window.location.href);
      return;
    }

    if (!isAdminPath && wasAdminPath && !window.clarity) {
      window.location.replace(window.location.href);
    }
  }, [pathname]);
};
